FD.CONTROL = (function ($, me) {
    'use strict';

    var child = me.CONTROL || {};


    /* ========================================================================
     *  private vars
     * ========================================================================
    */

    var ELEM = '[data-fd="url"]';
    var hitEnter = false;

    $.widget("custom.url", {
        options: {
            useParent: true,
            parentId: -1,
            value: '',
            initial: '',
            max: 200,                   //  max length
            min: 0,                     //  min length
            length: 0,                  //  length
            repeat: false,              //  repeat input
            focus: false,
            noedit: false,
            clearonload: false,
            submitevent: 'blur',
            delay: 800
        },
        _handleKeyUp: function (event) {
            var self = event.data;
            
            //  esc
            if (Number(event.which) === keyCode.ESC || Number(event.keyCode) === keyCode.ESC) {
                self.element.val(self.options.initial);
                me.setInputFocus(self.element, false);
                return;
            }

            //  enter
            if (Number(event.which) === keyCode.ENTER || Number(event.keyCode) === keyCode.ENTER) {
                hitEnter = true;
                self.element.blur();

                //  repeat 
                if (self.options.repeat && self.options.submitevent === 'enter') {
                    self.element.focus();
                }
                return;
            }
        },
        _handleKeyDown: function (event) {
            var self = event.data;
            if (Number(event.which) === keyCode.BACKSPACE || Number(event.keyCode) === keyCode.BACKSPACE || Number(event.which) === keyCode.TAB || Number(event.keyCode) === keyCode.TAB) {
                return true;
            }

            if (self.element.val().length > self.options.max) {
                return false;
            }
        },
        _handleFocus: function (event) {
            var self = event.data;

            self.options.initial = self.element.val();

            if (self.options.focus === true) {
                self.element.select();
            }
        },
        _handleBlur: function (event) {
            var self = event.data;

            if ((self.options.submitevent === 'enter' && !hitEnter) || (self.options.submitevent === 'tab' && hitEnter)) {
                self.options.initial = self.element.val();
                return;
            }
            if (self.element.val() === self.options.initial && !hitEnter) {
                return;
            }
            hitEnter = false;
            self._triggerCallback();
        },
        _handleChange: function (event) {
            var self = event.data;
            self._triggerCallback();
        },
        _triggerCallback: function () {
            this.validate();
            me.setCallBackFromData(this.element, { e: this.element, value: this.options.value, initial: this.options.initial, tag: this.options.tag, parentid: this.options.parentid, length: this.options.length || 0 });
            this.options.initial = this.options.value;
        },
        _create: function () {
            this.options = $.extend({}, this.options, this.element.data());
            me.setControlItemOptions(this.element, this.options);

            this.element.addClass("url");
            this.outerWraper = $('<div>');
            this.schemaWraper = $('<div class="input-group-prepend">\
    <select class="fd-formcontrol">\
      <option>http://</option>\
      <option>https://</option>\
    </select>\
  </div>');
            this.schemaDropdown = $("select", this.schemaWraper);
            this.schemaDropdown.on("change", this, this._handleChange);

            this.element.wrap(this.outerWraper);
            this.element.before(this.schemaWraper);

            this.element
                .on("keyup", this, this._handleKeyUp)
                .on("keydown", this, this._handleKeyDown)
                .on("focus", this, this._handleFocus)
                .on("blur", this, this._handleBlur);

            if (this.options.clearonload) {
                this.element.val('');
                this.options.clearonload = false;
                this.options.clearonload = false;
                this.element.attr('data-clearonload', false);
            }

            if (this.options.noedit) {
                this.element.attr('readonly', true);
                this.button.attr('readonly', true);
            }
            this.validate();
            this.refresh();
        },
        _setOptions: function (options) {
            this._super(options);
            this.refresh();
        },
        refresh: function () {

        },
        _destroy: function () {
            this.element.removeClass("url");
            this.element
                .off("keyup", this._handleKeyUp)
                .off("keydown", this._handelKeyDown)
                .off("focus", this._handleFocus)
                .off("blur", this._handleBlur);
            this.element.unwrap(this.outerWraper);
            this.schemaWraper.remove();
        },
        validate: function () {
            var val = this.element.val().trim();

            if (val.startsWith("http://")) {
                this.schemaDropdown.val("http://");
                val = val.substr(7);
            }
            if (val.startsWith("https://")) {
                this.schemaDropdown.val("https://");
                val = val.substr(8);
            }

            if (val.length < this.options.min) {
                val = this.options.initial;
            }

            this.element.val(val);
            if (val.length == 0)
                this.options.value = "";
            else
                this.options.value = this.schemaDropdown.val() + val;
            this.options.length = val.length;

            if (this.options.repeat) {
                this.element.val('');
            }
        },
        value: function (value) {
            if (value != undefined) {
                this.element.val(value);
                this._triggerCallback();
            }
            return this.options.value;
        }
    });
    
    var keyCode = {
        ENTER: 13,
        BACKSPACE: 8,
        ESC: 27,
        TAB: 9
    };

    /* ========================================================================
     *  private methods
     * ========================================================================
    */

    
    //  get text 
    function getUrl(container) {
        $(ELEM, container).url();
    }

    /* ========================================================================
     *  public methods
     * ========================================================================
    */


    child.setUrl = function (container) {
        getUrl(container);
    };


    /* ========================================================================
     *  return
     * ========================================================================
    */
    return child;
}(jQuery, FD));